<div
  [ngClass]="{
    'input-field': true,
    'input-field--auto-validate': control,
    'input-field--valid': valid,
    'input-field--invalid': invalid,
    'input-field--disabled': disabled,
  }"
>
  @if (label) {
    <label class="form-label" [htmlFor]="id">{{ label }}</label>
  }

  <div
    class="form-control-container"
    [ngClass]="{
      'form-control-container--has-icon': !!icon,
      'form-control-container--is-password': isPassword,
      'form-control-container--icon-right': iconPosition === 'end',
    }"
  >
    @if (icon) {
      <span class="form-control-icon material-symbols-outlined">{{ icon }}</span>
    }

    <input
      class="form-control"
      placeholder="{{ placeholder }}"
      [id]="id"
      [type]="type"
      [mask]="mask"
      [disabled]="disabled"
      [readonly]="readonly"
      [attr.minlength]="minLength"
      [attr.maxlength]="maxLength"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      (blur)="onTouched()"
    />

    @if (isPassword) {
      <button type="button" class="btn-visibility" (click)="handlerVisibility()">
        <span class="material-symbols-outlined">
          {{ type === 'text' ? 'visibility' : 'visibility_off' }}
        </span>
      </button>
    }
  </div>

  @if (control && control.errors && control.touched) {
    <cx-form-errors [control]="control" />
  } @else if (hintText) {
    <span class="form-hint-text">{{ hintText }}</span>
  }
</div>
